import { uniq } from 'lodash';
import React, { CSSProperties } from 'react';
import { createUseStyles } from 'react-jss';
import { colorsModeUI, MODE_UI_OPTIONS } from '../../../../modeUI';
import './TimeLineLabels.css';

const useStyles = createUseStyles((theme: ReturnType<typeof colorsModeUI>) => ({
  container: (props: TimeLineLabelsProps) => ({
    backgroundColor: theme.CONTROL_UNIT_DETAILS_BACKGROUND_COLOR,
    color: theme.INFORMATION_COLOR,
    width: props.width,
    '&& div:nth-child(2n)': {
      backgroundColor: theme.CONTROL_UNIT_DETAILS_CHART_BACKGROUND_COLOR_ACCENT,
    },
  }),
}));

export const getLabelsFromData = (data: any[]) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_headers, ...dataEvents] = data;
  return uniq(dataEvents.map(([name, ..._others]) => name));
};
interface TimeLineLabelsProps {
  labels: string[];
  width: CSSProperties['width'];
  mode: MODE_UI_OPTIONS;
}
export const TimeLineLabels = (props: TimeLineLabelsProps) => {
  const { labels, width, mode } = props;
  const classes = useStyles({ ...props, theme: colorsModeUI(mode) });
  return (
    <div
      className={`TimeLineLabels__Container ${classes.container}`}
      style={{ width }}
    >
      {labels.map((label) => (
        <TimeLineLabelItem key={label} label={label} />
      ))}
    </div>
  );
};
interface TimeLineLabelItemProps {
  label: string;
}
const TimeLineLabelItem = ({ label }: TimeLineLabelItemProps) => {
  return <div className="TimeLineLabels__Item" title={label}>{label}</div>;
};
